import { formatWorkflowPath } from "context/workflowReference";

// A stored target: `{target, workflow, input_data}`. docs/specs/2026-09-29-workflow-reference-cleanup.md
export function readInvocationTarget(stored) {
  const value = (stored && stored.target) ? stored : { target: {} };
  return {
    org: value.target.org || null,
    blob: value.target.blob || null,
    revision: value.target.revision || null,
    session: value.target.session || null,
    workflow: value.workflow || null,
    inputData: value.input_data ?? null
  };
}

export function scheduleDescription(schedule) {
  return (schedule && schedule.description) || null;
}

export function formatInvocationTarget(schedule) {
  if ( !schedule || !schedule.invocation_target ) {
    return "No target";
  }
  const target = readInvocationTarget(schedule.invocation_target);
  if ( !target.blob ) {
    return JSON.stringify(schedule.invocation_target);
  }
  return [target.org, target.blob, target.revision, target.session].filter(Boolean).join(" / ");
}

export function formatTargetWorkflow(target) {
  return formatWorkflowPath(readInvocationTarget(target).workflow);
}
